import * as React from 'react';
import axios from "axios";
import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";

import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import { red } from "@mui/material/colors";
import Button from '@mui/material/Button';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import Rating from '@mui/material/Rating';
import Switch from '@mui/material/Switch';
import Container from '@mui/material/Container';
import Alert from '@mui/material/Alert';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import CircularProgress from '@mui/material/CircularProgress';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';

import { uploadCategoryImagesApiRequest, uploadImagesCloudinaryApiRequest } from "./../utils/utils";

import AdminMenuComponent from "../../../components/admin/AdminMenuComponent.js";
import ElementCardForPageComponent from "./ElementCardForPageComponent.js";
import { cyan } from "@mui/material/colors";

import isEmail from 'validator/lib/isEmail';
import isStrongPassword from 'validator/lib/isStrongPassword';
import isLength from 'validator/lib/isLength';
import equals from 'validator/lib/equals';

const config = require("../../../constants/constants.js")

const EditUserPageComponent = ({ updateUserApiRequest, fetchUser }) => {

  const [validated, setValidated] = useState(false);
  const [user, setUser] = useState([]);
  const [isAdminState, setIsAdminState] = useState(false);
  const [updateUserResponseState, setUpdateUserResponseState] = useState({ message: "", error: "" });

  const { id } = useParams();
  const navigate = useNavigate();

  const [name, setName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [address, setAddress] = useState("");
  const [country, setCountry] = useState("");
  const [zipCode, setZipCode] = useState("");
  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [password, setPassword] = useState("");
  const [repassword, setRepassword] = useState("");
  const [role, setRole] = useState("");
  const [isAdmin, setIsAdmin] = useState(false);

  const [shippingAddress, setShippingAddress] = useState([]);
  const [shippingAddressItem, setShippingAddressItem] = useState({});
  const [shippingNameSurname, setShippingNameSurname] = useState("");
  const [shippingPhone, setShippingPhone] = useState("");
  const [shippingStreet, setShippingStreet] = useState("");
  const [shippingZip, setShippingZip] = useState("");
  const [shippingCity, setShippingCity] = useState("");
  const [shippingProvince, setShippingProvince] = useState("");

  const [fieldNameError, setFieldNameError] = useState(false);
  const [fieldLastnameError, setFieldLastnameError] = useState(false);
  const [fieldEmailError, setEmailFieldError] = useState(false);
  const [fieldPasswordError, setFieldPasswordError] = useState(false);
  const [fieldRePasswordError, setFieldRePasswordError] = useState(false);

  useEffect(() => {
    fetchUser(id)
      .then(data => {
        console.log(`data =`, data);
        setName(data?.name);
        setLastName(data?.lastName);
        setEmail(data?.email);
        setPhoneNumber(data?.phoneNumber);
        setAddress(data?.address);
        setCountry(data?.country);
        setZipCode(data?.zipCode);
        setCity(data?.city);
        setState(data?.state);
        setPassword(data?.password);
        setRepassword(data?.password);
        setRole(data?.role);
        setIsAdmin(data?.isAdmin);
        setShippingAddress(data?.shippingAddress[0]);
        setShippingNameSurname(data?.shippingAddress[0].nameSurname);
        setShippingPhone(data?.shippingAddress[0].phone);
        setShippingStreet(data?.shippingAddress[0].address);
        setShippingZip(data?.shippingAddress[0].zip);
        setShippingCity(data?.shippingAddress[0].city);
        setShippingProvince(data?.shippingAddress[0].province);
        console.log(`name  =`, name);
        console.log(`lastName  =`, lastName);
        console.log(`email  =`, email);
        console.log(`phoneNumber  =`, phoneNumber);
        console.log(`address  =`, address);
        console.log(`country  =`, country);
        console.log(`zipCode  =`, zipCode);
        console.log(`city  =`, city);
        console.log(`state  =`, state);
        console.log(`password  =`, password);
        console.log(`role  =`, role);
        console.log(`isAdmin  =`, isAdmin);
        console.log(`shippingAddress =`, shippingAddress);
      })
      .catch((er) => console.log(er.response.data.message ? er.response.data.message : er.response.data));
  }, [id])

  function salvaUserModificato(eventKey) {
    eventKey.preventDefault();
    eventKey.stopPropagation();

    console.log(`name dig =`, name);
    console.log(`lastName dig =`, lastName);
    console.log(`email dig =`, email);
    console.log(`phoneNumber dig =`, phoneNumber);
    console.log(`address dig =`, address);
    console.log(`country dig =`, country);
    console.log(`zipCode dig =`, zipCode);
    console.log(`city dig =`, city);
    console.log(`state dig =`, state);
    console.log(`password dig =`, password);
    console.log(`role dig =`, role);
    console.log(`code isAdmin =`, isAdmin);

    //setIsAdmin(false);

    const formInputs = {
      name: name,
      lastName: lastName,
      email: email,
      role: role,
      isAdmin: isAdmin,
      address: address,
      city: city,
      country: country,
      phoneNumber: phoneNumber,
      state: state,
      zipCode: zipCode,
      password: password,
      shippingAddress: {
        nameSurname: shippingNameSurname,
        address: shippingStreet,
        zip: shippingZip,
        city: shippingCity,
        province: shippingProvince,
        phone: shippingPhone,
        description: "",
        note: "",
      }

    };

    if (
      name &&
      lastName &&
      email &&
      password &&
      repassword &&
      (password === repassword)
    ) {

      updateUserApiRequest(id, formInputs)
        .then(data => {
          if (data.success === "user updated") {
            navigate("/admin/users");
          }
        })
        .catch(er => {
          setUpdateUserResponseState({ error: er.response.data.message ? er.response.data.message : er.response.data });
        })

      window.location.assign('/admin/users')
    }

  }

  function gotoIndietro(eventKey) {
    eventKey.preventDefault();
    eventKey.stopPropagation();

    window.location.assign('/admin/users')
  }

  const handleSelectRole = (event) => {
    setRole(event.target.value);
  };

  return (

    <Box sx={{ flexGrow: 1 }}>

      <Grid container spacing={2}>

        <AdminMenuComponent></AdminMenuComponent>

        <Box
          paddingLeft={{ xs: 3, md: 3 }}
        >

          <Breadcrumbs separator="›" aria-label="breadcrumb"
            size={{ xs: 12, md: 4 }}
            paddingTop={{ xs: 3, md: 3 }}
            paddingLeft={{ xs: 0, md: 0 }}
            paddingRight={{ xs: 1, md: 8 }}
            spacing={{ xs: 2, md: 2 }}
          >
            <Link underline="hover" color="inherit" href="">
              {config.BC_ADMIN}
            </Link>
            <Link underline="hover" color="inherit" href="/admin/users">
              {config.BC_ADMIN_USERS}
            </Link>
            <Typography sx={{ color: 'text.primary' }}>{config.BC_ADMIN_USERS_EDIT}</Typography>
          </Breadcrumbs>

          <Stack
            sx={{ flexDirection: { xs: "row", md: "row" }, paddingTop: 2, paddingLeft: 0, paddingRight: 0, }}
          >

            <Typography
              sx={{ paddingTop: 0, paddingLeft: 0, paddingRight: 0, }}
              variant="h4"
            >
              <b>Modifica utente</b>&nbsp;
            </Typography>

          </Stack>

          <Box
            sx={{
              paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
              height: 20
            }}
          />

          <Paper
            sx={{
              paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
              background: '#cce0e6'
            }}
            elevation={6}
          >

            <Stack
              useFlexGap
              sx={{
                flexDirection: { xs: "column", md: "row" },
                paddingTop: 2, paddingLeft: 0, paddingRight: 0,
                flexWrap: 'wrap'
              }}
            >

              <TextField id="id-name" label="Nome" variant="outlined" value={name} defaultValue={name}
                sx={{
                  width: "35ch",
                  p: { xs: 1, md: 1 },
                  m: { xs: 1, md: 1 },
                }}
                error={fieldNameError}
                onChange={(event) => {
                  setName(event.target.value);
                  if (isLength(event.target.value, { min: 3, max: 15 })) {
                    setFieldNameError(false);
                  } else {
                    setFieldNameError(true);
                  }
                }}
              />

              <TextField id="id-lastName" label="Cognome" variant="outlined" value={lastName} defaultValue={lastName}
                sx={{
                  width: "35ch",
                  p: { xs: 1, md: 1 },
                  m: { xs: 1, md: 1 },
                }}
                error={fieldLastnameError}
                onChange={(event) => {
                  setLastName(event.target.value);
                  if (isLength(event.target.value, { min: 3, max: 15 })) {
                    setFieldLastnameError(false);
                  } else {
                    setFieldLastnameError(true);
                  }
                }}
              />

              <TextField id="id-email" label="Email" variant="outlined" value={email} defaultValue={email}
                sx={{
                  width: "35ch",
                  p: { xs: 1, md: 1 },
                  m: { xs: 1, md: 1 },
                }}
                error={fieldEmailError}
                onChange={(event) => {
                  setEmail(event.target.value);
                  if (isEmail(event.target.value)) {
                    setEmailFieldError(false);
                  } else {
                    setEmailFieldError(true);
                  }
                }}
              />

              <TextField id="id-phoneNumber" label="Telefono" variant="outlined" value={phoneNumber} defaultValue={phoneNumber}
                sx={{
                  width: "20ch",
                  p: { xs: 1, md: 1 },
                  m: { xs: 1, md: 1 },
                }}
                onChange={(event) => {
                  setPhoneNumber(event.target.value);
                }}
              />

              <TextField id="id-address" label="Indirizzo" variant="outlined" value={address} defaultValue={address}
                sx={{
                  width: "35ch",
                  p: { xs: 1, md: 1 },
                  m: { xs: 1, md: 1 },
                }}
                onChange={(event) => {
                  setAddress(event.target.value);
                }}
              />
              <TextField id="id-city" label="Città" variant="outlined" value={city} defaultValue={city}
                sx={{
                  width: "25ch",
                  p: { xs: 1, md: 1 },
                  m: { xs: 1, md: 1 },
                }}
                onChange={(event) => {
                  setCity(event.target.value);
                }}
              />
              <TextField id="id-country" label="Provincia" variant="outlined" value={country} defaultValue={country}
                sx={{
                  width: "25ch",
                  p: { xs: 1, md: 1 },
                  m: { xs: 1, md: 1 },
                }}
                onChange={(event) => {
                  setCountry(event.target.value);
                }}
              />
              <TextField id="id-zipCode" label="Cap" variant="outlined" value={zipCode} defaultValue={zipCode}
                sx={{
                  width: "15ch",
                  p: { xs: 1, md: 1 },
                  m: { xs: 1, md: 1 },
                }}
                onChange={(event) => {
                  setZipCode(event.target.value);
                }}
              />

              <FormControl
                sx={{
                  width: "35ch",
                  p: { xs: 1, md: 1 },
                  m: { xs: 1, md: 1 },
                }}
              >
                <InputLabel id="demo-simple-select-label">
                  Ruolo
                </InputLabel >
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={role}
                  label="Ruolo"
                  onChange={handleSelectRole}
                >
                  <MenuItem value="Utente">Utente</MenuItem>
                  <MenuItem value="Cliente">Cliente</MenuItem>
                  <MenuItem value="Admin">Admin</MenuItem>
                  <MenuItem value="Owner">Owner</MenuItem>
                </Select>
              </FormControl>

              <TextField id="id-password" label="Password" variant="outlined" value={password} defaultValue={password} type="password"
                sx={{
                  width: "25ch",
                  p: { xs: 1, md: 1 },
                  m: { xs: 1, md: 1 },
                }}
                error={fieldPasswordError}
                onChange={(event) => {
                  setPassword(event.target.value);
                  if (isStrongPassword(event.target.value)) {
                    setFieldPasswordError(false);
                  } else {
                    setFieldPasswordError(true);
                  }
                }}
              />

              <TextField id="id-repassword" label="Ripeti password" variant="outlined" value={repassword} defaultValue={repassword} required type="password"
                sx={{
                  width: "25ch",
                  p: { xs: 1, md: 1 },
                  m: { xs: 1, md: 1 },
                }}
                error={fieldRePasswordError}
                onChange={(event) => {
                  setRepassword(event.target.value);
                  if (isStrongPassword(event.target.value)) {
                    setFieldRePasswordError(false);
                  } else {
                    setFieldRePasswordError(true);
                  }
                }}
              />

              <Box
                component="fieldset"
                sx={{
                  border: 1,
                  background: '	#d0e6f5ff',
                  p: { xs: 1, md: 1 },
                  m: { xs: 1, md: 1 },
                }}
              >

                <legend>&nbsp;&nbsp;indirizzo spedizione&nbsp;&nbsp;</legend>

                <TextField id="id-name" label="Cognome e nome" variant="outlined" value={shippingNameSurname} defaultValue={shippingNameSurname}
                  sx={{
                    width: "30ch",
                    p: { xs: 1, md: 1 },
                    m: { xs: 1, md: 1 },
                  }}
                  error={fieldNameError}
                  onChange={(event) => {
                    setShippingNameSurname(event.target.value);
                    if (isLength(event.target.value, { min: 3, max: 15 })) {
                      setFieldNameError(false);
                    } else {
                      setFieldNameError(true);
                    }
                  }}
                />

                <TextField id="id-address" label="Indirizzo" variant="outlined" value={shippingStreet} defaultValue={shippingStreet}
                  sx={{
                    width: "30ch",
                    p: { xs: 1, md: 1 },
                    m: { xs: 1, md: 1 },
                  }}
                  onChange={(event) => {
                    setShippingStreet(event.target.value);
                  }}
                />

                <TextField id="id-zipCode" label="Cap" variant="outlined" value={shippingZip} defaultValue={shippingZip}
                  sx={{
                    width: "15ch",
                    p: { xs: 1, md: 1 },
                    m: { xs: 1, md: 1 },
                  }}
                  onChange={(event) => {
                    setShippingZip(event.target.value);
                  }}
                />

                <TextField id="id-city" label="Città" variant="outlined" value={shippingCity} defaultValue={shippingCity}
                  sx={{
                    width: "25ch",
                    p: { xs: 1, md: 1 },
                    m: { xs: 1, md: 1 },
                  }}
                  onChange={(event) => {
                    setShippingCity(event.target.value);
                  }}
                />
                
                <TextField id="id-country" label="Provincia" variant="outlined" value={shippingProvince} defaultValue={shippingProvince}
                  sx={{
                    width: "25ch",
                    p: { xs: 1, md: 1 },
                    m: { xs: 1, md: 1 },
                  }}
                  onChange={(event) => {
                    setShippingProvince(event.target.value);
                  }}
                />

                <TextField id="id-phone" label="Telefono" variant="outlined" value={shippingPhone} defaultValue={shippingPhone}
                  sx={{
                    width: "25ch",
                    p: { xs: 1, md: 1 },
                    m: { xs: 1, md: 1 },
                  }}
                  onChange={(event) => {
                    setShippingPhone(event.target.value);
                  }}
                />


              </Box>

            </Stack>

            <Box
              sx={{
                display: 'flex',
                flexDirection: { xs: "row", md: "row" },
                alignItems: "center",
                justifyContent: "center"
              }}
            >

              <Button
                type="button"
                variant="contained"
                color="warning"
                onClick={(e) => { gotoIndietro(e); }}
                sx={{
                  width: "12ch",
                  p: { xs: 1, md: 1 },
                  m: { xs: 1, md: 1 },
                }}
              >
                Indietro
              </Button>

              <Button
                type="button"
                variant="contained"
                color="success"
                onClick={(e) => { salvaUserModificato(e); }}
                sx={{
                  width: "12ch",
                  p: { xs: 1, md: 1 },
                  m: { xs: 1, md: 1 },
                }}
              >
                Salva
              </Button>

            </Box>

            <Box
              sx={{
                paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                height: 20
              }}
            />

          </Paper>

          <Box
            sx={{
              paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
              height: 40
            }}
          />

        </Box>

      </Grid>

    </Box>

  );
};

export default EditUserPageComponent;
